import { render, staticRenderFns } from "./Col6BigReviewers.vue?vue&type=template&id=75b1fcad&scoped=true"
import script from "./Col6BigReviewers.vue?vue&type=script&lang=js"
export * from "./Col6BigReviewers.vue?vue&type=script&lang=js"
import style0 from "./Col6BigReviewers.vue?vue&type=style&index=0&id=75b1fcad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b1fcad",
  null
  
)

export default component.exports